import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  GetActivePage,
  checkMinimumDPI,
  getEditorRatio,
} from '../../redux/helpers';
import {
  fill,
  fit,
  maximumDrag,
} from '../../redux/helpers/canvas';

import Texture from '../texture/Texture';

import {
  calculateStyle,
  calculateBorderStyle,
  calculcatePlaceholderStyle } from './../../helpers/canvasHelpers';

class Canvas extends Component {
  static contextTypes = {
    redux: React.PropTypes.object,
  }
  constructor(args) {
    super(...args);

    this.dragActions = {
      mouseMove: {
        x: 0,
        y: 0,
      },
      startPosition: {
        x: 0,
        y: 0,
      },
      dragPosition: {
        x: 0,
        y: 0,
      },
    };

    this.dragStartX = 0;
    this.dragStartY = 0;

    this.draggedCanvas = 0.0;
    this.thumbnailRatio = 1;
    this.state = {
      mousePressed: false,
      drag: false,
      visibleOverlay: false,
      targetId: 0,
      isChange: false,
      imagesLoaded: false,
    };
    this.setTimeout = null;
    this.startRendering = this.startRendering.bind(this);
    this.stopRendering = this.stopRendering.bind(this);
    this.images = [];
    this.imagesArray = [];
    this.runOnce = false;
  }

  componentWillReceiveProps(nextProps) {
    const ifIsNormalBook = !this.state.imagesLoaded && nextProps.imagesLoaded === 'loaded' && nextProps.bookProperties.autofill === false;
    const ifIsAutofill = !this.state.imagesLoaded && nextProps.imagesLoaded === 'loaded' && nextProps.autofillFinished && nextProps.bookProperties.autofill;
    if ((ifIsAutofill || ifIsNormalBook) && !this.runOnce) {
      Object.values(nextProps.images.byId).filter((element) => {
        if (element.mediumThumbnail) {
          this.imagesArray.push(element.mediumThumbnail);
        }
      });

      if (!this.state.imagesLoaded) {
        Promise.all(this.loadImages(this.imagesArray)).then(() => {
          this.setState({
            imagesLoaded: true,
          });
        });
      }
      this.runOnce = true;
    }
  }


  shouldComponentUpdate(nextProps) {
    const isAutofillFinishedOrNormalBook = (nextProps.convertFinished && nextProps.imagesLoaded === 'loaded') || (nextProps.autofillFinished && nextProps.bookProperties.autofill) || !nextProps.bookProperties.autofill;

    if (isAutofillFinishedOrNormalBook) {
      return true;
    }

    return false;
  }


  renderCanvas(placeholders) {
    if (!placeholders) {
      return;
    }

    return placeholders.map(this.renderTexture);
  }

  renderBackgroundPlaceholder(backgroundPlaceholders) {
    if (backgroundPlaceholders && Object.keys(backgroundPlaceholders).length === 0) {
      return;
    }

    return backgroundPlaceholders.map(this.renderSingleBackgroundPlaceholder);
  }

  renderSingleBackgroundPlaceholder = (texture) => {
    const {
      pages,
      layouts,
      bookProperties,
      isPreview,
    } = this.props;

    const activePage = GetActivePage(pages);
    const { layout } = activePage;

    const coverRatio = {
      width: layouts.byId[layout] ? layouts.byId[layout].width : 0,
      height: layouts.byId[layout] ? layouts.byId[layout].height : 0,
    };

    const ratio = getEditorRatio('.Editor', activePage, coverRatio, bookProperties.bookSizes);
    const StyleWidth = isPreview ? bookProperties.placeholderBorderSize * ratio : bookProperties.placeholderBorderSize / bookProperties.bookSizes.ratio;
    const shadow = {
      boxShadow: `0px 0px ${StyleWidth / 2}px ${StyleWidth / 2}px rgba(0, 0, 0, 0.2)`,
    };
    const placeholderstyle = Object.assign(calculateStyle(texture, ratio), shadow);

    return (
      <div
        key="background01"
        className="backgroundPlaceholder"
        style={placeholderstyle}
      />
    );
  }

  renderTexture = (texture, index) => {
    const {
      id,
      imageRatio,
    } = texture;

    const {
      pages,
      isChange,
      images,
      layouts,
      bookProperties,
      isPreview,
      backgroundType,
      lang,
    } = this.props;
    const activePage = GetActivePage(pages);
    const { layout } = activePage;

    const coverRatio = {
      width: layouts.byId[layout] ? layouts.byId[layout].width : 0,
      height: layouts.byId[layout] ? layouts.byId[layout].height : 0,
    };

    const ratio = getEditorRatio('.Editor', activePage, coverRatio, bookProperties.bookSizes);
    const placeholderstyle = calculcatePlaceholderStyle(texture, ratio);


    const pageId = activePage.id;

    const DPIResolution = false;

    const StyleWidth = isPreview ? bookProperties.placeholderBorderSize * ratio : bookProperties.placeholderBorderSize / bookProperties.bookSizes.ratio;
    const BorderStyle = calculateBorderStyle(texture, ratio, StyleWidth);

    const canvasOVerlayStyle = {
      display: this.state.visibleOverlay && this.state.targetId === id ? 'block' : 'none',
    };

    return (
      <div
        key={`wrap-${index}`}
      >
        <div
          className="canvasOverlay"
          style={canvasOVerlayStyle}
          role="presentation"
          key={`overlay-${index}`}
        />
        <div className="canvasBorder" style={backgroundType === 'tematikus' ? BorderStyle : {}} />
        <div
          key={index}
          className="tools"
          style={calculateStyle(texture, ratio)}
        >

          <Texture
            layouts={this.props.layouts}
            texture={texture}
            style={placeholderstyle}
            ratio={ratio}
            droppedImages={activePage.droppedImages}
            activePageplaceholders={activePage.placeholders}
            placeholders={this.props.layoutplaceholders}
            isChange={isChange}
            pageId={pageId}
            pages={pages}
            images={images.byId}
            index={index}
            imageRatio={imageRatio}
            DPIResolution={DPIResolution}
          />
        </div>
      </div>
    );
  }

  renderImages() {
    const canvas = document.querySelectorAll('canvas');
    if (canvas.length > 0 && canvas !== null) {
      Object.values(canvas).map((canvasNode) => {
        const placeholderId = canvasNode.getAttribute('data-placeholderid');
        this.setImageToCanvas(canvasNode, placeholderId);
      });
    }
  }


  componentDidUpdate() {
    this.renderImages();
  }

  setImageToCanvas(canvasNode, placeholderId) {
    const context = canvasNode.getContext('2d');
    const url = canvasNode.getAttribute('data-image-url');
    const originalImageWidth = canvasNode.getAttribute('data-imagewidth');
    const isChanged = canvasNode.getAttribute('data-isChanged');

    if (!this.props.layoutplaceholders[placeholderId]) {
      return;
    }

    const {
      scaleX,
      scaleY,
      moveX,
      moveY,
      isFit,
      fillSizes,
    } = this.props.layoutplaceholders[placeholderId].transformations;

    let { imageRatio } = this.props.layoutplaceholders[placeholderId];
    const placeholderImage = this.props.layoutplaceholders[placeholderId].imageObject;

    const rotate = this.props.layoutplaceholders[placeholderId] ? (this.props.layoutplaceholders[placeholderId].transformations.rotate) * Math.PI / 180 : 0;
    const originalPlaceholderWidth = this.props.layoutplaceholders[placeholderId].width;
    if (url && !isChanged) {
      if (Object.keys(this.images).length > 0) {
        const imageObject = Object.values(this.images).find(element => element.src === url);
        context.clearRect(0, 0, canvasNode.width, canvasNode.height);

        if (imageObject) {
          if (rotate === 1.5707963267948966 || rotate === 4.71238898038469) {
            imageRatio = fillSizes.width / placeholderImage.originalHeight;
          }

          this.drawFillImage(context, imageRatio, rotate, imageObject, canvasNode, scaleX, scaleY, moveX / imageRatio, moveY / imageRatio, isFit, originalPlaceholderWidth, originalImageWidth, placeholderId);
        }
      }
    } else {
      context.clearRect(0, 0, canvasNode.width, canvasNode.height);
    }
  }

  setDebounce = () => {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 1000);
  }

  loadImages(images) {
    const loadedImages = this.images;
    const promiseArray = images.map((imgurl) => {
      const prom = new Promise(((resolve) => {
        const img = new Image();
        img.onload = function () {
          loadedImages[imgurl] = img;
          resolve();
        };
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = imgurl;
      }));
      return prom;
    });

    return promiseArray;
  }


  drawDraggedCanvas(src, context, canvasStyle, isFit, placeholderId) {
    const required = ['moveX', 'moveY', 'scaleX', 'angle'];
    const validProperties = required.every(element => Object.keys(canvasStyle).indexOf(element) > -1);
    if (!validProperties) {
      throw new Error('Missing object properties.');
    }

    let {
      moveX, moveY,
    } = canvasStyle;
    const { scaleX, angle } = canvasStyle;
    const mouseX = this.dragActions.mouseMove.x;
    const mouseY = this.dragActions.mouseMove.y;

    moveX > 0 ? moveX : mouseX;
    moveY > 0 ? moveY : mouseY;

    if (this.state.mousePressed) {
      if (!this.state.drag && this.state.targetId === parseInt(placeholderId, 10)) {
        this.dragActions.startPosition.x = mouseX - moveX;
        this.dragActions.startPosition.y = mouseY - moveY;
      }
      this.setState({
        drag: true,
      });
    }

    const placeholderData = this.props.layoutplaceholders[placeholderId];

    if (placeholderData === undefined) {
      return;
    }

    const originalImage = {
      width: placeholderData.imageObject.width,
      height: placeholderData.imageObject.height,
      scale: placeholderData.transformations.scaleX,
      fillSizes: placeholderData.transformations.fillSizes,
      placeholderWidth: placeholderData.width,
      placeholderHeight: placeholderData.height,
      imageRatio: placeholderData.imageRatio,
    };


    const thumbnailSize = {
      width: src.width,
      height: src.height,
    };

    const thumbnailRatio = originalImage.height / thumbnailSize.height;

    this.thumbnailRatio = thumbnailRatio;
    if (this.state.mousePressed && this.state.targetId === parseInt(placeholderId, 10)) {
      moveX = mouseX - this.dragActions.startPosition.x;
      moveY = mouseY - this.dragActions.startPosition.y;
      const drags = maximumDrag(angle, originalImage.height, originalImage.width, originalImage.fillSizes, originalImage.placeholderHeight, originalImage.placeholderWidth, originalImage.imageRatio);
      moveX = moveX > 0 ? 0 : (moveX >= -drags.moveX || moveX === 0) ? moveX : -drags.moveX;
      moveY = moveY > 0 ? 0 : (moveY >= -drags.moveY || moveY === 0) ? moveY : -drags.moveY;
      this.dragActions.dragPosition.x = (moveX / scaleX);
      this.dragActions.dragPosition.y = (moveY / scaleX);
    }

    isFit ? fit(context, src, angle) : fill(context, src, (moveX / thumbnailRatio), (moveY / thumbnailRatio), angle, scaleX, 0);
  }

  drawFillImage(ctx, imageRatio, angle, image, canvas, scaleX, scaleY, moveX, moveY, isFit, originalPlaceholderWidth, originalImageWidth, placeholderId) {
    const {
      lang,
      bookProperties,
    } = this.props;


    checkMinimumDPI(ctx, imageRatio, originalImageWidth, originalPlaceholderWidth, lang, bookProperties.bookSizes);
    ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2);
    ctx.rotate(angle);
    ctx.scale(scaleX, scaleY);
    ctx.translate(-ctx.canvas.width / 2, -ctx.canvas.height / 2);

    const canvasStyle = {
      moveX,
      moveY,
      scaleX,
      angle,
    };

    const degree = angle * (180 / Math.PI);

    if (degree === 0) {
      ctx.setTransform(scaleX, 0, 0, scaleX, 0, 0);
    }
    if (degree === 90) {
      ctx.setTransform(
        0,
        scaleX,
        -scaleX,
        0,
        ctx.canvas.width - (((ctx.canvas.width - ctx.canvas.height) / 2) * scaleX),
        -(((ctx.canvas.width - ctx.canvas.height) / 2) * scaleX),
      );
    }
    if (degree === 180) {
      ctx.setTransform(-scaleX, 0, 0, -scaleX, ctx.canvas.width, ctx.canvas.height);
    }
    if (degree === 270) {
      ctx.setTransform(
        0,
        -scaleX,
        scaleX,
        0,
        -(((ctx.canvas.height - ctx.canvas.width) / 2) * scaleX),
        ctx.canvas.height - (((ctx.canvas.height - ctx.canvas.width) / 2) * scaleX),
      );
    }


    this.drawDraggedCanvas(image, ctx, canvasStyle, isFit, placeholderId);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }

  startRendering = () => {
    this.setState({
      isChange: false,
    });
  }

  stopRendering = () => {

  }
  render() {
    const {
      placeholders,
      backgroundPlaceholders,
    } = this.props;
    return (
      <div>
        { this.renderCanvas(placeholders) }
        { backgroundPlaceholders && this.renderBackgroundPlaceholder(backgroundPlaceholders) }
      </div>
    );
  }
}

Canvas.defaultProps = {
  isChange: false,
  images: {},
  canvas: {},
  placeholders: [],
  bookProperties: {},
  layouts: {},
  width: 1400,
  height: 1400,
  transformations: {},
  imageObject: {},
  imagesLoaded: '',
  backgroundType: '',
  convertFinished: false,
  backgroundPlaceholders: [],
  isPreview: false,
};

Canvas.propTypes = {
  isChange: PropTypes.bool,
  images: PropTypes.object,
  canvas: PropTypes.object,
  placeholders: PropTypes.array,
  bookProperties: PropTypes.object,
  layouts: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  transformations: PropTypes.object,
  imageObject: PropTypes.object,
  imagesLoaded: PropTypes.string,
  backgroundType: PropTypes.string,
  convertFinished: PropTypes.bool,
  backgroundPlaceholders: PropTypes.array,
  isPreview: PropTypes.bool,
};

export default connect(state => ({
  canvas: state.editorUI.canvas,
  layoutplaceholders: state.entities.placeholders.byId,
  layouts: state.entities.layouts,
  images: state.entities.images,
  pages: state.entities.pages.byId,
  isChange: state.editorUI.imageChange.isChange,
  bookProperties: state.bookProperties,
  autofillFinished: state.entities.io.autofillFinished,
  convertFinished: state.entities.io.convertFinished,
  imagesLoaded: state.entities.io.imagesLoaded,
  backgroundType: state.editorUI.bookProperties.backgroundType,
}
))(Canvas);



// WEBPACK FOOTER //
// ./src/components/canvas/Canvas.jsx